module.exports = {
  title: '善行',
}
